// types
import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

export const AppConfig = Object.freeze({
  nodeEnv: import.meta.env.VITE_APP_NODE_ENV || 'prod',
  apiRoot: import.meta.env.VITE_APP_API_ROOT || '',
  socketRoot: import.meta.env.VITE_APP_SOCKET_ROOT || import.meta.env.VITE_APP_API_ROOT,
  graphqlApiRoot: import.meta.env.VITE_APP_GRAPHQL_API_ROOT || '',
  graphqlWs: import.meta.env.VITE_APP_GRAPHQL_WS || '',
  tokenKey: 'accessToken',
  adminTokenKey: 'adminAccessToken',
  clientIdKey: 'clientId',
  recaptchaKey: import.meta.env.VITE_APP_RECAPTCHA_KEY || '',
  tinymceToken: import.meta.env.VITE_APP_TINY_MCE_KEY || '',
  gtmId: import.meta.env.VITE_APP_GOOGLE_ANALYTICS_ID || '',
  rocketChatApiRoot: import.meta.env.VITE_APP_CHAT_API_ROOT || 'https://chat-dev.gridfunding.com'
});

// ==============================|| THEME CONFIG  ||============================== //

export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config: DefaultConfigProps = {
  defaultPath: '/merchants/mcas',
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  miniDrawer: true,
  container: false,
  mode: ThemeMode.DARK,
  presetColor: 'default',
  menuOrientation: MenuOrientation.VERTICAL,
  themeDirection: ThemeDirection.LTR
};

export default config;
